import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import firebase from 'firebase/app'
import "@firebase/auth";

import Landing from '../pages/Landing.vue'
import Home from '../pages/Home.vue'
import Documents from '../pages/Documents.vue'
import Faq from '../pages/Faq.vue'
import Prizes from '../pages/Prizes.vue'
import Contact from '../pages/Contact.vue'

import Privacy from '../pages/Privacy.vue'
import Login from '../pages/Login.vue'
import PasswordEmail from '../pages/PasswordEmail.vue'
import Register from '../pages/Register.vue'
import Dashboard from '../pages/Dashboard.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Home, meta: { navbar: true, footer: true } },
  { path: '/documenti', component: Documents, meta: { navbar: true, footer: true } },
  { path: '/faqs', component: Faq, meta: { navbar: true, footer: true } },
  { path: '/premi', component: Prizes, meta: { navbar: true, footer: true } },
  { path: '/contatti', component: Contact, meta: { navbar: true, footer: true } },
  { path: '/privacy-policy', component: Privacy, meta: { navbar: true, footer: true } },
  { path: '/register', component: Register, meta: { navbar: false, footer: false } },
  { path: '/login', component: Login, meta: { navbar: false, footer: false } },  
  { path: '/forgot-password', component: PasswordEmail, meta: { navbar: false, footer: false } },
  { path: '/dashboard', component: Dashboard, meta: { navbar: true, footer: false, auth: true } }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes,
  linkActiveClass: "font-bold"
})

router.beforeEach(async (to, from, next) => {    
    // redirect to homepage when reload browser page from a form view
    if ( to.meta.auth && !firebase.auth().currentUser) next('/login');     
    next();    
});

export default router
